import ScanScreen from "./index";

const routes = [
  {
    path: "/scan",
    component: ScanScreen,
  },
];

export default routes;
